import { ReactNode } from 'react';
import { Button, Skeleton } from '@heroui/react';
import { Location } from 'iconsax-react';
import {
  ProductStatus,
  ProductStatusProps,
} from '@ui/product/product-status.tsx';

export type PharmacyCardProps = {
  address?: string;
  name?: string;
  statuses?: ProductStatusProps[];
  variant?: 'select' | 'info' | 'edit';
  isLoading?: boolean;
  isDisabled?: boolean;
  children?: ReactNode;
  onPress?: () => void;
};

export const PharmacyCard = ({
  address = 'Адрес аптеки',
  name = 'Название аптеки',
  statuses = [],
  variant,
  isLoading = false,
  isDisabled = false,
  children,
  onPress,
}: PharmacyCardProps) => {
  return (
    <>
      <div className="flex flex-col gap-y-3 lg:gap-y-6">
        <div className="flex flex-row items-center gap-x-1.5">
          <Skeleton isLoaded={!isLoading} className="rounded-lg w-6 h-6">
            <Location size="20" color="#2D7BEF" />
          </Skeleton>
          <Skeleton isLoaded={!isLoading} className="rounded-lg">
            <p className="text-[#222222] lg:text-lg lg:font-semibold">
              {address}
            </p>
          </Skeleton>
        </div>

        <Skeleton isLoaded={!isLoading} className="rounded-lg">
          <p className="text-[#9CA5AC] text-sm lg:text-base">{name}</p>
        </Skeleton>

        {statuses?.map((item, index) => (
          <Skeleton key={index} isLoaded={!isLoading} className="rounded-lg">
            <ProductStatus {...item} />
          </Skeleton>
        ))}
      </div>

      {children}

      {variant && (
        <Skeleton isLoaded={!isLoading} className="pt-4 rounded-lg">
          {variant === 'select' && (
            <Button
              isDisabled={isDisabled}
              fullWidth
              color="primary"
              size="lg"
              onPress={onPress}
            >
              Выбрать аптеку
            </Button>
          )}

          {variant === 'info' && (
            <Button
              isDisabled={isDisabled}
              fullWidth
              color="primary"
              variant="bordered"
              size="lg"
              onPress={onPress}
            >
              Подробнее о товаре
            </Button>
          )}

          {variant === 'edit' && (
            <Button
              isDisabled={isDisabled}
              fullWidth
              variant="bordered"
              size="lg"
              onPress={onPress}
            >
              Изменить
            </Button>
          )}
        </Skeleton>
      )}
    </>
  );
};
